import { createServiceFactory } from '@/services/factory'
import { createMockDocumentService } from './documents.mock'
import { createHttpDocumentService } from './documents.http'

export type { DocumentService } from './documents.service'
export { documentEvidenceHttp } from './evidence.http'

export const getDocumentService = createServiceFactory(
  'documents',
  createMockDocumentService,
  createHttpDocumentService
)
